import { createSelector } from 'reselect';

export const getProjectData = (state) => state.projectData;

export const getCurrentProjectSC = createSelector(
  getProjectData,
  (projectData) => projectData.currentProject
);

export const getMessagesSC = createSelector(
  getProjectData,
  (projectData) => projectData.messages
);

export const getCurrentProjectImageSC = createSelector(
  getProjectData,
  (projectData) => projectData.currentProjectImage
);

export const getExecutorsSC = createSelector(
  getProjectData,
  (projectData) => projectData.executors
);

export const getWorkingHoursSumSC = createSelector(
  getCurrentProjectSC,
  (projectData) => projectData.workingHoursSum
);

export const getCurrentStepHoursSC = createSelector(
  getCurrentProjectSC,
  (projectData) => projectData.currentStepsHours
);

export const getProjectWasChangedSC = createSelector(
  getProjectData,
  (projectData) => projectData.isProjectWasChanged
);

export const getUnsavedProjectShowSC = createSelector(
  getProjectData,
  (projectData) => projectData.isUnsavedProjectShow
);

export const getProductToProjectSC = createSelector(
  getProjectData,
  (projectData) => projectData.productToProject
);
